<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const { t } = useI18n();

const SCOPES = ['this', 'following', 'all'];

const dialogRef = ref(null);
const mode = ref('edit');
const scope = ref('this');
let resolveScope = null;

const title = computed(() =>
  mode.value === 'delete'
    ? t('TASKS.RECURRENCE.SCOPE.DELETE_TITLE')
    : t('TASKS.RECURRENCE.SCOPE.EDIT_TITLE')
);

const ask = (requestedMode = 'edit') => {
  mode.value = requestedMode;
  scope.value = 'this';
  dialogRef.value?.open();
  return new Promise(resolve => {
    resolveScope = resolve;
  });
};

const settle = value => {
  resolveScope?.(value);
  resolveScope = null;
};

const handleConfirm = () => {
  settle(scope.value);
  dialogRef.value?.close();
};

defineExpose({ ask });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="sm"
    :title="title"
    :type="mode === 'delete' ? 'alert' : 'edit'"
    :confirm-button-label="t('TASKS.RECURRENCE.SCOPE.CONFIRM')"
    :cancel-button-label="t('TASKS.RECURRENCE.SCOPE.CANCEL')"
    @confirm="handleConfirm"
    @close="settle(null)"
  >
    <div class="flex flex-col gap-3">
      <label
        v-for="option in SCOPES"
        :key="option"
        class="flex items-center gap-3 text-sm text-n-slate-12 cursor-pointer"
      >
        <input v-model="scope" type="radio" :value="option" />
        {{ t(`TASKS.RECURRENCE.SCOPE.${option.toUpperCase()}`) }}
      </label>
    </div>
  </Dialog>
</template>
